import React, { useState } from "react";
// External Components
import Grid from "@mui/material/Grid";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
// Icons
import ScreenRotationIcon from "@mui/icons-material/ScreenRotationRounded";
import makeStyles from "@mui/styles/makeStyles";
var useStyles = makeStyles(function (_a) {
    var palette = _a.palette, spacing = _a.spacing;
    return ({
        modal: {
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
        },
        outerDiv: {
            outline: "none",
        },
        icon: {
            color: palette.secondary.light,
            backgroundColor: palette.grey[800],
            fontSize: "7rem",
            padding: spacing(2),
            borderRadius: "10%",
        },
        text: {
            color: palette.secondary.light,
            textAlign: "center",
        },
    });
});
export default (function () {
    var _a = useState(true), open = _a[0], setOpen = _a[1];
    var handleClose = function () {
        setOpen(false);
    };
    var classes = useStyles();
    return (React.createElement(Modal, { open: open, onClose: handleClose, className: classes.modal },
        React.createElement("div", { className: classes.outerDiv },
            React.createElement(Grid, { item: true, sm: 12 },
                React.createElement(Typography, { align: "center" },
                    React.createElement(ScreenRotationIcon, { className: classes.icon })),
                React.createElement(Typography, { variant: "h3", className: classes.text }, "Rotate Screen")))));
});
//# sourceMappingURL=index.js.map